import { render, staticRenderFns } from "./AvaliacoesMenu.vue?vue&type=template&id=5b549259"
import script from "./AvaliacoesMenu.vue?vue&type=script&lang=js"
export * from "./AvaliacoesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports